import { Injectable } from '@angular/core';
import { CanActivate, Router, Params } from '@angular/router';
import { CURRENT_CLAIM_NUMBER } from '@prcins/constants';

@Injectable({ providedIn: 'root' })
export class ClaimNavigationService implements CanActivate {
  constructor(private router: Router) {}

  navigateToClaim(claimNumber: string, queryParams?: Params): void {
    sessionStorage.setItem(CURRENT_CLAIM_NUMBER, claimNumber);
    this.router.navigate(['/eservice/home/claims'], { queryParams });
  }

  canActivate(): boolean {
    this.router.navigate(['/eservice/home/claims/claimslist']);
    return false;
  }
}
